import {
    convertLegacyPageExtension,
    convertLegacyPlugin,
} from "@backstage/core-compat-api";
import { createFrontendFeatureLoader } from "@backstage/frontend-plugin-api";

import { adminDevToolsModule, AdminPage, adminPlugin } from "./plugin";

export { adminDevToolsModule, AdminPage, adminPlugin };

/**
 * Default export so NFS auto-discovery (which only reads
 * `require(pkg).default`) picks up both the converted legacy plugin and
 * the devtools sub-page module via `app.packages: all`.
 */
export default createFrontendFeatureLoader({
    loader: async () => [
        convertLegacyPlugin(adminPlugin, {
            extensions: [
                convertLegacyPageExtension(AdminPage, { path: "/admin" }),
            ],
        }),
        adminDevToolsModule,
    ],
});
